import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
  Suspense,
} from "react";
import { TextLink } from '@vbg-ds/core';
import { Button, ButtonGroup } from '@vds/buttons';
import { useDispatch, useSelector } from "react-redux";
import {  Title } from "@vds/typography";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { Notification } from "@vds/notifications";
import { Text } from '@vds/core';
import { Grid, Row, Col } from "@vds/grids";
import { DropdownSelect } from "@vds/selects";
import { useMediaQuery } from "react-responsive";
import {
  ErrorBoundary,
  PromoBannerLarge,
  SEOTagger,
  SpinnerComponent,
} from "../../../../common/components";
import {
  GridwallFilterBar,
  GridwallFilterBoxes,
} from "../../../../common/components/GridwallFilterBar";
import useToggle from "../../../../hooks/useToggle";
import useStickyHeaderHeight from "hooks/useStickyHeaderHeight";
import useGlobalData from "hooks/useGlobalData";
import * as SiteAnalytics from "../../../../sitecatalyst";
import * as SiteAnalyticsVZDL from "../../../../sitecatalyst/VZDLSiteCatalyst.js"
import { getProductType } from "../../../../utils/productTypeUtil";
import { MarginSpacer2XL, MarginSpacerXL } from "common/components/styleTag";
import { FLOWS, setGWPlansID, setGWDeviceType, setCategory, setProgressSteps, setCurrentActivePage, setProgressBarFlow, setCategoryForHPB, setStoreGridwallPDP, setReinitiateFlow, setCurrentFlowForHPB, setCompletedPagesForHPB, setCurrentActiveStep } from "app/ducks/GlobalSlice";
import {
  getGridwallList,
  setCategoryName,
  setCompareDevices,
  setDeviceId,
  setGridwallList,
  setSelectedSku,
  setSkuData,
  setDeviceName,
  setBrandsList,
  setFilterSelected,
  setProductDetail,
  setTradeInToggleValue,
  setIsPlansFirstCategory,
  setPDPFeatureList,
  addToCartJointOffer,
  addToCart,
  getZipCodeForBuyNowFlow
} from "../../ducks/MobilitySlice";
import GridwallTabs from "./GridwallTabs";
import GridwallHeader from "./GridwallHeader";
import styled from "styled-components";
import "./MobilityGridwall.css";
import {
  GridwallTabBar,
  CustomGridwallContainer,
  GridwallStickyTabBar,
} from "./styles";
import { LQWidgetModal } from "./LQWidgetModal";
import { ClearAll } from "@mui/icons-material";
const GridwallPlansFirstDevices = React.lazy(() => import("./GridwallPlansFirstDevices"));
import POYDNotification from "../POYD/POYDNotification";
import POYDMaxDeviceModal from "common/components/ProductDetails/modals/POYDMaxDeviceModal";

const SEOFooter = React.lazy(() => import("./SEOFooter/SEOFooter"));
const GridwallCompare = React.lazy(() => import("./GridwallCompare"));
const StickyHeaderVds3 = React.lazy(() =>
  import("common/components/StickyHeader/StickyHeaderVds3")
);
const Gridwall = React.lazy(() =>
  import("common/components/Gridwall/Gridwall")
);
const PromoBanner = React.lazy(() =>
  import("common/components/PromoBanner/PromoBanner")
);

const MobilityGridwall = (props) => {
  const [brandFilter, setBrandFilter] = useState(props?.brandFilter || '');
  const [searchParams, setSearchParams] = useSearchParams();
  const { t, ready } = useTranslation(["gridwall", "app"], { useSuspense: false });
  const aem = t("gridwall", { ns: "gridwall", returnObjects: true }) || {};
  // const showTradeInToggle = t('showTradeInToggle', { ns: "app" });
  const enableFreeTab = t('enableFreeTab', { ns: "app" });
  const plansFirstCategories = t('plans-first.category', { ns: "app", returnObjects: true });
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const globalData = useSelector((state) => state.GlobalData);
   const showTradeInToggle = globalData?.metaInformation?.tradeinToggle ? "Y" : "N";
  const pageData = useSelector((state) => state.MobilityPage);
  const fourGData = useSelector((state) => state.Landing4GPage);
  const length =
    pageData?.compareDevices && Object.keys(pageData.compareDevices).length;
  const plansFirstDevicesCount = pageData?.plansFirstDevices && Object.keys(pageData.plansFirstDevices).length;
  const sessionCartData =
    globalData?.sessionCartData?.apiResponse?.prospectFlowData;
  const bogoOfferId = pageData?.bogoOfferId;
  const isBogo =
    searchParams.get("type") &&
    searchParams.get("type") === "GET" &&
    bogoOfferId;
  const pageNumParam = searchParams.get("page") || 1;
  const gridwallRef = useRef();
  const [showFilters, toggleFilters] = useToggle(false);
  const [showFiltersTypes, toggleFiltersTypes] = useToggle(false);
  const [showCartDetailsModal, setshowCartDetailsModal] = useState(false);
  const [pageNumClicked, setPageNum] = useState(null);
  const [showSeoFooter, setShowSeoFooter] = useState(false);
  const [seoFooterData, setSeoFooterData] = useState(null);
  const planFirstData = useSelector((state) => state.PlanFirst);
  const [tradeInToggle, setTradeInToggle] = useState(showTradeInToggle === "Y" ? true : false);
  const [detailsClick,onDetailsClick] = useState(false)
  const [filterData, setFilterData] = useState({
    brandList: {
      type: "brandList",
      key: "",
    },
    simTypeList: [
      { key: "eSim", name: "eSIM" }
    ]
  });
  const [clearAll, showClearAll] = useState(false);
  const mixedCartApplied = sessionCartData?.cart?.mixedCartApplied?.includes('REGULAR_4G') || sessionCartData?.cart?.mixedCartApplied?.includes('REGULAR_5G') || false;
  const isPOYDFlow = pageData?.isPOYDFlow;
  const [showPOYDMaxDeviceModal, setShowPOYDMaxDeviceModal] = useState(false);

  useEffect(() => {
    setTradeInToggle(showTradeInToggle === "Y" ? true : false);
  }, [ready])

  useEffect(() => {
    let brandListData = filterData["brandList"];
    let list = [];
    if (brandListData instanceof Map) {
      for (const [key, value] of brandListData) {
        list.push({ key });
      }
    }
    if (list.length >= 1) dispatch(setBrandsList(list));
  }, [filterData]);

  const isMobile = useMediaQuery({
    query: "(max-width:545px)",
  });

  const isMobileFixedResolution = useMediaQuery({
    query: "(min-width: 546px) and (max-width: 767px)",
  });

  const categoryList = sessionStorage.getItem("categoryList");
  let isSamePage = false;
  const [deviceFilters, setDeviceFilters] = useState({
    brandList: (brandFilter !== "Free" && props?.brandFilter !== "Free") ?
      brandFilter ?? props?.brandFilter
        ? [
          {
            type: "brandList",
            key: brandFilter ?? props?.brandFilter,
            docCount: 0,
            checked: true,
          },
        ]
        : pageData?.filterApplied?.brandList && (isSamePage || categoryList === props?.category || props?.category === "all")
          ? pageData?.filterApplied?.brandList 
          : []
      : [],
    baseOfferList: (brandFilter === "Free" || props?.brandFilter === "Free") ?
      [{
        imageUrl: null,
        key: "Free offers",
        docCount: 0,
        checked: true,
        name: null,
        type: "baseOfferList"
      }]
      : [],
    simTypeList: props?.simFilter
      ? [
        {
          type: "simTypeList",
          key: props?.simFilter,
          docCount: 0,
          checked: true,
        },
      ]
      : pageData?.filterApplied?.simTypeList
        ? pageData?.filterApplied?.simTypeList
        : [],
    colorList: pageData?.filterApplied?.colorList
      ? pageData?.filterApplied?.colorList
      : [],
    categoryList:
      
      props?.is5gsmartphones
        ? [
          {
            type: "categoryList",
            key: "PDA/SmartPhones",
            docCount: 0,
            checked: true,
            name: "Smartphones",
          },
        ]
        : pageData?.filterApplied?.categoryList &&
          !props?.brandFilter &&
          props?.category === "all"
          ? pageData?.filterApplied?.categoryList
          : [],
    sorDeviceCategoryList: pageData?.filterApplied?.sorDeviceCategoryList
      ? pageData?.filterApplied?.sorDeviceCategoryList
      : [],
    compatibilityList: pageData?.filterApplied?.compatibilityList
      ? pageData?.filterApplied?.compatibilityList
      : [],
    preOwnedDevices: pageData?.filterApplied?.preOwnedDevices
      ? pageData?.filterApplied?.preOwnedDevices
      : [],
    sorSkuTypeList: String(window.location.pathname).includes(
      "certified-pre-owned"
    )
      ? [
        {
          imageUrl: null,
          key: "OCPO",
          docCount: 11,
          checked: true,
          name: null,
          type: "sorSkuTypeList",
        },
      ]
      : pageData?.filterApplied?.sorSkuTypeList
        ? pageData?.filterApplied?.sorSkuTypeList
        : [],
    technologyTypeList: pageData?.filterApplied?.technologyTypeList
      ? pageData?.filterApplied?.technologyTypeList
      : [],
    basicColorList: (pageData?.filterApplied?.basicColorList && !pageData?.isFromShoppingCart)
      ? pageData?.filterApplied?.basicColorList
      : [],
  });
  const [clearAllFilters, setShowClearAllFilters] = useState(false)
  const sortByValue = window.sessionStorage.getItem("sortBy");
  const [sortBy, setSortBy] = useState(
    ((pageData?.deviceSelectedForExceedginCreditLimit !== null &&
      pageData?.deviceSelectedForExceedginCreditLimit) || (pageData?.deviceSelectedForExceedginCreditLimitNew !== null && pageData?.deviceSelectedForExceedginCreditLimitNew))
      ? sortDeviceOptions[1].value
      : sortByValue !== undefined ? sortByValue : sortDeviceOptions[0].value
  );
  const [searchValue, setSearchValue] = useState("");
  const [openLQModal,setOpenLQModal] = useState(false)
  const [deviceList, setDeviceList] = useState([]);
  const [setDeviceTabForOCPO, handleDeviceTab] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [showCompareLimitModal, setShowCompareLimitModal] = useState(false);
  const [gridPage, setGridPage] = useState(1);
  const [currentPath, setCurrentPath] = useState("");
  const [showByodModal, toggleByodModal] = useToggle();
  const [viewResults, setViewResults] = useState(false);
  const [loadEmptyDataContainer, handleLoadContainer] = useState(false);
  const [dataReady, setDataReady] = useState(false);
// As part of api optimization --> Session cart is getting called twice
  const { metaInformation, allGlobalPromos } = useGlobalData({ skipSessionCart: true });
  const showBuyNowFlowNSE = metaInformation?.showBuyNowNSE;
  const showBuyNowFlowJointOffer = metaInformation?.showBuyNowJointOffer;
  const { stickyHeaderRef, headerHeight } =
    useStickyHeaderHeight(sessionCartData);

  const isOneTalk = props?.isOneTalk ? props?.isOneTalk : false;
  const is5gsmartphones = props?.is5gsmartphones ?? false;
  const isTabLayout = String(props?.layout).includes("tabs");
  const isSearchLayout = String(props?.layout).includes("search");
  const isQualModalOpen = aem?.isQualmodel;

  const selectedCompare = useMemo(
    () => Object.keys(pageData?.compareDevices ?? {}),
    [pageData?.compareDevices]
  );

  const isPlanFirstFlow = useMemo(
    () =>
      globalData?.flow === FLOWS.PLANFIRST &&
      Object.values(globalData?.sessionCartData?.devices || {})?.filter(
        (i) => i?.deviceFullDetail?.dummy
      )?.length,
    [globalData?.flow, globalData?.sessionCartData?.devices]
  );

  const handleImgClick = () => {
    toggleByodModal();
  };

  const getUpdateSearchParams = () => {
    let paramsPlanId = (searchParams.get("planId"))?.match(/\d+/)[0];
    if (paramsPlanId) { dispatch(setGWPlansID(paramsPlanId)); }
    let paramsDeviceType = (searchParams.get("deviceType"));
    if (paramsDeviceType) { dispatch(setGWDeviceType(paramsDeviceType)); }
  };

  const PAGE_SIZE = window?.mbtGlobal?.uiConfig?.GLOBAL_PARAM_GWPAGESIZE || 14;
  const BASE_PATH = "/shop/products/devices/";
  const globalPromos = allGlobalPromos?.gridwall;
  const isLoading = pageData?.loading;
  const isVBC = window?.mbtGlobal?.flags?.ENABLE_VBC_PROSPECT === "Y" && !globalData?.IsVBCClearCartClicked ? true :false;
  const enableBuyNowFlow = aem?.enableBuyNowFlow
  const isLaptopSelected = deviceFilters?.categoryList?.find(
    (i) => i?.checked && String(i?.key)?.toLowerCase()?.includes("laptop")
  );

  const byodCard = useMemo(() => {
    let cat = deviceList[0]?.category?.includes("BroadbandAccess Devices")
      ? "mobile-hotspots"
      : props?.category;
    if(cat === "mobile-hotspots") {
      cat = deviceList?.some(device => !device.category?.includes("BroadbandAccess Devices")) ? "all" : cat
    }
    return {
      title: t("gridwall.byod.byod-card-heading", { ns: "gridwall" }),
      description: t("gridwall.byod.use-your-own-device", { ns: "gridwall" }),
      handleImgClick,
      promo: globalPromos?.byodTile?.heading,
      position: isVBC ? (showBuyNowFlowNSE && showBuyNowFlowJointOffer) ? Number(t(`gridwall.byodVBC.buyNowBYODPosition.${cat}`, { ns: "gridwall" })) : Number(
        t(`gridwall.byodVBC.reactPosition.${cat}`, { ns: "gridwall" })
      ):
      Number(
        t(`gridwall.byod.reactPosition.${cat}`, { ns: "gridwall" })
      ),     
    };
  }, [globalPromos, props?.category, location, ready, deviceList]);
  const GWJointOfferCard = useMemo(() => {
    const cat = deviceList[0]?.category?.includes("BroadbandAccess Devices")
      ? "mobile-hotspots"
      : props?.category;
    return {
      title: t("gridwall.GWJointOffer.heading", { ns: "gridwall" }),
      description: t("gridwall.GWJointOffer.subheading", { ns: "gridwall" }),
      handleImgClick,
      promo: globalPromos?.byodTile?.heading,
      position: enableBuyNowFlow ? Number(t(`gridwall.GWJointOffer.buyNowJOPosition.${cat}`, { ns: "gridwall" })) : Number(
        t(`gridwall.GWJointOffer.reactPosition.${cat}`, { ns: "gridwall" })
      ),
    };
  }, [globalPromos, props?.category, location, ready, deviceList]);
  useEffect(() => {
    let getClearAllForDeviceFilters = { ...deviceFilters }
    let count = 0
    if (getClearAllForDeviceFilters === null || getClearAllForDeviceFilters === undefined ||
      Object.keys(getClearAllForDeviceFilters).length === 0) setShowClearAllFilters(false)
    else {
      if (location?.pathname?.includes("certified-pre-owned")) { delete getClearAllForDeviceFilters["sorSkuTypeList"] }
      
      Object.values(getClearAllForDeviceFilters).map(data => {
        if (data === null || data === undefined || data.length === 0) count++
      })
      if (count === Object.keys(getClearAllForDeviceFilters).length) { setShowClearAllFilters(false) }
      else { setShowClearAllFilters(true) }
    }
  }, [deviceFilters])

  useEffect(() => {
    if (
      props?.isCategory &&
      (sessionStorage.getItem("categoryList") === undefined ||
        sessionStorage.getItem("categoryList") === null)
    )
      sessionStorage.setItem("categoryList", props?.category);
    initGridwallData();
    setCurrentPath(location.pathname.replace(BASE_PATH, ""));
  }, [location]);

  useEffect(() => {
    dispatch(setTradeInToggleValue(tradeInToggle));
  }, [tradeInToggle])


  useEffect(() => {
    let data = { ...aem?.seoBodyCopy };
    let keyFound = false;
    if (data && Object.keys(data).length > 0) {
      Object.keys(data).forEach((key) => {
        if (
          window?.location?.href?.indexOf(key) > -1 &&
          window?.location?.href?.lastIndexOf(key) + key?.length ===
          window?.location?.href?.length
        ) {
          keyFound = true;
          setShowSeoFooter(true);
          setSeoFooterData(aem?.seoBodyCopy[key]);
        }
      });
      if (!keyFound) {
        setShowSeoFooter(false);
        setSeoFooterData(null);
      }
    }
  }, [ready, props?.category, deviceFilters]);

  const listOfPaths = ["laptops", "mobile-hotspots", "smart-watches", 'desk-conference-phones'];
  const pathnotIncluded = !listOfPaths.some((item) =>
    location.pathname.includes(item)
  );

  useEffect(() => {
    handleLoadContainer(false);
    window.sessionStorage.setItem("_flowName", "Device");
    SiteAnalytics.trackPageInfo();
    SiteAnalyticsVZDL.trackPageInfoVZDL("Device Gridwall","NSE","Digital Prospect")
    dispatch(setPDPFeatureList([]));
  }, []);

  useEffect(() => {
    if (
      ((props?.isCategory && isSamePage) || !props?.isCategory) &&
      pageData?.filterApplied !== null &&
      pageData?.filterApplied
    )
      setDeviceFilters({
        ...pageData?.filterApplied,
        categoryList: props?.isCategory 
          ? []
          : pageData?.filterApplied?.categoryList || [],
        brandList: !!props?.brandFilter
          ? [
            {
              type: "brandList",
              key: props?.brandFilter,
              docCount: 0,
              checked: true,
            },
          ]
          : pageData?.filterApplied?.brandList || [],
        simTypeList: props?.simFilter
          ? [
            {
              type: "simTypeList",
              key: props?.simFilter,
              docCount: 0,
              checked: true,
            },
          ]
          : pageData?.filterApplied?.simTypeList || [],
      });
  }, [pageData?.filterApplied, ready]);

  useEffect(() => {
  
    if (pageData?.gridwall?.serviceStatus?.success) {
      handleLoadContainer(true);
      if (pageData?.gridwall?.data?.deviceList?.length) {

        const pageInfo = pageData?.gridwall?.data?.pageInfo;
        const pageNum = pageInfo?.pageSize
          ? pageInfo?.offset / pageInfo?.pageSize + 1
          : 1;
        const list = [];
        list.push(...(pageData?.gridwall?.data?.deviceList || []));
        setGridPage(pageNum);
        setDeviceList(list);
        setTimeout(function(){
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        }) },0)
      
        parseFilterData(pageData?.gridwall?.data?.deviceFilters);
        setTotalResults(pageData?.gridwall?.data?.totalHits);
        setHasMore(list.length <= pageData?.gridwall?.data?.totalHits);
        if (
          setDeviceTabForOCPO.length == 0 &&
          props?.cpoFilter !== null &&
          props?.cpoFilter &&
          props?.cpoFilter === "OCPO" &&
          pageData?.gridwall?.data?.deviceFilters !== null &&
          pageData?.gridwall?.data?.deviceFilters &&
          Object.keys(pageData?.gridwall?.data?.deviceFilters).length > 0
        ) {
          const lowerCaseData = [...aem?.ocpoTabs].map((data) =>
            String(data).toLowerCase()
          );
          const { deviceFilters } = pageData?.gridwall?.data;
          const { brandList } = deviceFilters;
          let resultData = ["All"];
          brandList.map((data) => {
            if (
              lowerCaseData.includes(String(data.key).toLowerCase()) &&
              data.docCount > 0
            )
              resultData.push(data.key);
          });
          handleDeviceTab(resultData);
        }
        dispatch(setGridwallList({}));
       
        setDataReady(true);
        
      } else {
        setHasMore(false);
        dispatch(setGridwallList({}));
        setDeviceList([]);
        setTotalResults(0);
      }
      setSearchValue("");
    } else if (
      pageData?.gridwall?.serviceStatus &&
      pageData?.gridwall?.serviceStatus?.success === false
    ) {
      setDataReady(true);
    }
  }, [pageData?.gridwall]);

 
  const sanitizeNumber = (x) => {
    if (!x || isNaN(x)) {
      return 1;
    } else if (Number.isSafeInteger(Number(x))) {
      return Number(x);
    } else {
      return 1;
    }
  };


  useEffect(() => {
    if (pageNumClicked) {
      const params = searchParams;
      if (
        params.get("page") !== null &&
        params.get("page") &&
        Number(pageNumClicked) !== 1 &&
        Number(pageNumClicked) != Number(params.get("page"))
      ) {
        params.set("page", sanitizeNumber(pageNumClicked));
        setSearchParams(params);
        getUpdateSearchParams();
      }
    }
  }, [pageNumClicked]);

  const waitforBtnClick = false;

  if (waitforBtnClick) {
    useEffect(() => {
      if ((Object.keys(filterData)?.length || viewResults)) fetchNextItems(); 
    }, [sortBy, viewResults, ready]);
  } else {
    useEffect(() => {
      if (Object.keys(filterData)?.length) fetchNextItems();  
    }, [sortBy, deviceFilters]);
  }
  const getCategory = (deviceFilters) => {
    
    return Object.entries(deviceFilters?.categoryList || {}).length === 1 
    && String(Object.entries(deviceFilters?.categoryList)[0][1].name).toUpperCase() === 'Smartphones'.toUpperCase()
    ? 'smartphones' : 'all'
  }
  const getCategoryForHPB = (deviceFilters) => {
    return Object.entries(deviceFilters?.categoryList || {}).length === 1 
    ? String(Object.entries(deviceFilters?.categoryList)[0][1].name) : 'all'
  }
  const getFilterPayload = ({ filter, redFilter }) => {
    let filterResult = {};
    let keyForFilter = [];
    if (filter !== null && filter && Object.keys(filter).length)
      keyForFilter = [...keyForFilter, ...Object.keys(filter)];
    if (redFilter !== null && redFilter && Object.keys(redFilter).length)
      keyForFilter = [...keyForFilter, ...Object.keys(redFilter)];
    keyForFilter.forEach((key) => {
      
      if (
        redFilter?.[key] &&
        Object.values(redFilter[key]).length
      )
        filterResult = { ...filterResult, [key]: redFilter[key] };
        if (
          filter?.[key] && Object.values(filter[key])?.length
        )
          filterResult = { ...filterResult, [key]: filter[key] };
    });
    return filterResult;
  };
  const fetchNextItems = useCallback(
    (pageNum = pageNumParam, filters = deviceFilters) => {
      const requestBody = {
        category: props?.category,
        offset: (pageNum - 1) * PAGE_SIZE, // pages start with 1
        pageSize: PAGE_SIZE,
        sortBy: sortBy,
        deviceFilters: getFilterPayload({
          filter: filters,
          redFilter: filters?.categoryList,
        }),
        searchValue: searchValue,
        isOneTalk: !!props?.isOneTalk,
        bagxOfferIdList: isBogo && bogoOfferId ? [bogoOfferId] : [],
        plansFirstFlow: globalData?.flow === 'plans-first' ? globalData?.flow : globalData?.flow === "PLANFIRST" ? globalData?.flow : 'prospect',
      };
      dispatch(setCategory(props?.category !== 'all' ? props?.category : getCategory(requestBody?.deviceFilters)));
      dispatch(setCategoryForHPB(props?.category !== 'all' ? props?.category : getCategoryForHPB(requestBody?.deviceFilters)));
      dispatch(setIsPlansFirstCategory(checkPlansFirstCategory(filters)))
      dispatch(getGridwallList(requestBody));
      setViewResults(false);
      setPageNum(pageNum);
    },
    [
      props?.category,
      sortBy,
      pageData?.filterApplied,
      deviceFilters,
      searchValue,
      props?.isOneTalk,
      isBogo,
      bogoOfferId,
    ]   
  );

  const initGridwallData = () => {
    if (
      categoryList != null &&
      categoryList &&
      props?.isCategory &&
      categoryList === props?.category
    )
      isSamePage = true;
    else if (
      categoryList != null &&
      categoryList &&
      categoryList !== props?.category &&
      props?.isCategory
    ) {
      sessionStorage.setItem("categoryList", props?.category);
      isSamePage = false;
    }
    let filters = {};
    if (props?.isCategory && !isSamePage)
      dispatch(setFilterSelected({ ...filters }));
    else filters = { ...filters, ...pageData?.filterApplied };
    if (props?.brandFilter && props?.brandFilter !== "Free") {
      filters["brandList"] = [
        {
          type: "brandList",
          key: props?.brandFilter,
          docCount: 0,
          checked: true,
        },
      ];
    }
    if (props?.brandFilter == "Free") {
      filters["baseOfferList"] =
        [{
          imageUrl: null,
          key: "Free offers",
          docCount: 0,
          checked: true,
          name: null,
          type: "baseOfferList"
        }]
    }
    if (props?.is5gsmartphones) {
      filters["categoryList"] = [
        {
          type: "categoryList",
          key: "PDA/SmartPhones",
          docCount: 0,
          checked: true,
          name: "Smartphones",
        },
      ];
    }
    if (props?.cpoFilter) {
      filters["sorSkuTypeList"] = [
        {
          type: "sorSkuTypeList",
          key: props?.cpoFilter,
          docCount: 0,
          checked: true,
        },
      ];
    }
    if (props?.simFilter) {
      filters["simTypeList"] = [
        {
          type: "simTypeList",
          key: props?.simFilter,
          docCount: 0,
          checked: true,
        },
      ];
    }
    setDeviceFilters(filters);
  };

    const checkForHPBFlow = () => {
    if (globalData.flow === 'plans-first' && globalData.isPlanFirstFlowCompleted) {
      dispatch(setCurrentFlowForHPB(""))
      dispatch(setCompletedPagesForHPB([]))
      dispatch(setCurrentActiveStep(0))
    } else {
      const initialPath = String(window.location.pathname).split('/')
      const initialPathLength = initialPath.length
      const getSwitchPath = (initialPath[initialPathLength - 2] + '/' + initialPath[initialPathLength - 1])
    }
  }

  const onGridwallClickHandler = useCallback(
    (seoUrlName, deviceId, selectedSku, category) => {
      if(pageData?.isPOYDFlow && sessionCartData?.cart?.packages &&
            Object.keys(sessionCartData?.cart?.packages).length ){
        setShowPOYDMaxDeviceModal(true);
      }else{
      dispatch(setProductDetail(""));
      dispatch(setDeviceId(deviceId));
      dispatch(setSelectedSku(selectedSku));
      dispatch(setSkuData(selectedSku));
      dispatch(setDeviceName(seoUrlName));
      dispatch(setStoreGridwallPDP(seoUrlName))
      const catName = getProductType(category);
      dispatch(setCategoryName(catName));
      checkForHPBFlow()
      let url = location?.pathname?.replace("/shop", "");
      if (props?.category === "all") {
        if (ready) {
          const brandTabVals = new Set([
            ...aem?.categoryTabs,
            ...aem?.tabletTabs,
            ...aem?.ocpoTabs,
          ]);
          for (const c of brandTabVals) {
            if (url.includes(`/${String(c)?.toLowerCase()}`)) {
              url = url.replace(`/${String(c)?.toLowerCase()}`, `/${catName}`);
            }
          }
        }
      }
      if (url.includes("/certified-pre-owned")) {
        url = url.replace("/certified-pre-owned", `/${catName}`);
      }
      const deviceCat = [
        "/free",
        "/apple",
        "/samsung",
        "/motorola",
        "/google",
        "/kyocera",
        "/tcl",
      ];
      deviceCat.forEach((dev) => {
        if (String(url).includes(dev)) url = url.replace(dev, "/");
      });
      const simCat = ["/esim"];
      simCat.forEach((i) => {
        if (String(url).includes(i)) url = url.replace(i, "/");
      });
      const simType = deviceFilters?.simTypeList?.find(
        (i) => i?.checked === true
      )?.key;
      navigate(`${url}/${seoUrlName}${isBogo ? "?type=GET" : ""}`, {
        state: {
          color: selectedSku?.cssColor,
          simType,
        },
      });
    }
    },
    [ready, aem, props?.category, deviceFilters]
  );

  const parseFilterData = (filters) => {
    if (!Object.keys(filters)?.length) return;
    const result = {};
    for (const filterList of Object.keys(filters)) {
      if (Array.isArray(filters[filterList])) {
        const filterMap = new Map();
        for (const f of filters[filterList]) {
          filterMap.set(f.key, { ...f, type: filterList });
        }
        result[filterList] = filterMap;
      }
    }
    setFilterData(result);
  };

  const removeCompareDevice = (deviceId) => {
    const selected = pageData?.compareDevices ?? {};
    let newSelected = { ...selected };
    delete newSelected[deviceId];
    dispatch(setCompareDevices(newSelected));
  };

  const onCompareSelect = useCallback(
    (item) => {
      const selected = pageData?.compareDevices ?? {};
      const deviceId = item?.deviceId;
      if (Object.keys(selected).includes(deviceId)) {
        removeCompareDevice(deviceId);
      } else if (Object.keys(selected)?.length < 4) {
        let newSelected = { ...selected };
        newSelected[deviceId] = item;
        dispatch(setCompareDevices(newSelected));
      } else {
        setShowCompareLimitModal(true);
      }
    },
    [pageData?.compareDevices]
  );

  useEffect(() => {
    let clearAllLoc = false;
    if (deviceFilters.paymentList == "") {
      setDeviceFilters({ ...deviceFilters });
    }
    if (
      deviceFilters === null ||
      deviceFilters === undefined ||
      Object.keys(deviceFilters).length === 0
    )
      clearAllLoc = false;
    else if (
      deviceFilters !== null &&
      deviceFilters &&
      Object.keys(deviceFilters).length
    ) {
      let count = 0;
      Object.values(deviceFilters).forEach((data) => {
        if (data?.length === 0 || data === undefined || data === null) count++;
      });
      if (count === Object.keys(deviceFilters).length) clearAllLoc = false;
      else clearAllLoc = true;
    }
    if(!pageData?.isFromShoppingCart){
    showClearAll(false);}
  }, [deviceFilters, ready]);

  const onClearFilter = () => {
    if (props?.brandFilter || props?.simFilter) {
      resetToBasePath();
    }
    setBrandFilter("All");
    setDeviceFilters({
      sorSkuTypeList: String(window.location.pathname).includes(
        "certified-pre-owned"
      )
        ? [
          {
            imageUrl: null,
            key: "OCPO",
            docCount: 11,
            checked: true,
            name: null,
            type: "sorSkuTypeList",
          },
        ]
        : [],
    });

    dispatch(
      setFilterSelected({
        sorSkuTypeList: String(window.location.pathname).includes(
          "certified-pre-owned"
        )
          ? [
            {
              imageUrl: null,
              key: "OCPO",
              docCount: 11,
              checked: true,
              name: null,
              type: "sorSkuTypeList",
            },
          ]
          : [],
        
      })
    );
  
  };

  const filterAll = [
    {
      name: aem?.labels?.frpFilterTitle,
      value: "priceList",
    },
    {
      name: aem?.labels?.simFilterTitle,
      value: "simTypeList",
    },
    {
      name: aem?.labels?.Category,
      value: "categoryList",
    },
    {
      name: aem?.labels?.brand,
      value: "brandList",
    },
    {
      name: aem?.labels?.color2,
      value: "basicColorList",
    },
    {
      name: aem?.labels?.Capability,
      value: "compatibilityList",
    },
    {
      name: aem?.labels?.preOwnedDevices,
      value: "sorSkuTypeList",
    },
  ];

  const resetToBasePath = () => {
    let path = String(window.location.pathname)
      .split("/")
      .filter((i) => !!i);
    path.pop();
    let pathRedirection = path[path.length - 1];
    if (path[path.length - 1] === "devices") pathRedirection = "all";
    setCurrentPath("all");
    navigate(BASE_PATH + pathRedirection);
  };

  const reloadGWPath = () => {
    let path = String(window.location.pathname)
      .split("/")
      .filter((i) => !!i);
    if(path[path.length - 3] === "devices") path.pop();
    let pathRedirection = path[path.length - 1];
    if (path[path.length - 2] === "devices") pathRedirection = "all";
    setCurrentPath("all");
    navigate(BASE_PATH + pathRedirection);
  };
  useEffect(() => {
          dispatch(getZipCodeForBuyNowFlow())
},[showBuyNowFlowNSE,showBuyNowFlowJointOffer])
  const checkPlansFirstCategory = (filters) => {
    let nonSmartphones = Object.fromEntries(Object.entries(filters?.categoryList || {}).filter(([k,v]) => {
      return v?.name?.toLowerCase() !== 'smartphones' ? true : false
    }))
    return Object.keys(nonSmartphones || {})?.length > 0 ? false : true
  } 
const onClickHandlerPopularDevice = ()=>{
        const payload = t("gridwall.placeHolderPopularDevicePayload", { ns: "gridwall", returnObjects: true, zipCode: pageData?.zipCodeForBuyNowFlow ?? "30004" })  
        dispatch(addToCart({ ...payload, routeTo: () => { navigate("/shop/shopping-cart") } }));
    }
  const onClickHandlerLTEDevice = (qualified) => {
    console.log(qualified,'qwerty')
      setOpenLQModal(false)
      const payLoadNSEFlow = t("gridwall.placeHolderNSEPayload", { ns: "gridwall", returnObjects: true, zipCode: pageData?.zipCodeForBuyNowFlow ?? "30004"})
      const payloadLTEFlow = t(`gridwall.${qualified === '4G' ? 'placeHolderLTEPayload' : 'placeHolderFIVEGPayload'}`, { ns: "gridwall", returnObjects: true , zipCode: pageData?.zipCodeForBuyNowFlow ?? "30004"})
      const obj = { payLoadNSEFlow: { ...payLoadNSEFlow, routeTo: () => { navigate("/shop/shopping-cart") } }, payloadLTEFlow }
      dispatch(addToCartJointOffer(obj));
  }


  return (
    <ErrorBoundary>
      {openLQModal ? 
      <LQWidgetModal opened={openLQModal} onOpenedChange={setOpenLQModal} handleQualification={onClickHandlerLTEDevice}/>:<></>}
      <MobilityGridwallWrap>
        {!ready && <SpinnerComponent />}
        <SEOTagger pageName={"prospect"} />
        <Suspense fallback={<></>}>
          {globalPromos && currentPath && (
            <PromoBanner
              promoData={globalPromos[currentPath] ?? globalPromos.page}
              overrideBgColor={"#E10014"}
              overrideTextColor={"#ffffff"}
            />
          )}
        </Suspense>
        <Suspense fallback={<></>}>
          {sessionCartData?.cart?.packages &&
            Object.keys(sessionCartData?.cart?.packages).length ? (
            <StickyHeaderVds3
              onCartClick={() => {
                navigate("/shop/shopping-cart");
              }}
              disabledContinueBtn={true}
              hideAddress={true}
              hideContinueButton={true}
              enableBackLink={!!isBogo}
              backClickHandler={() => navigate(-1)}
              pdp={true}
              notSticky={false}
              hideShoppingBagIcon={isPlanFirstFlow}
              hideTotals={true}
              showChatAndContact={true}
               isOneTalk={isOneTalk}
          showCartDetailsModal={showCartDetailsModal}
          setshowCartDetailsModal={setshowCartDetailsModal}
            />
          ) : (
            <></>
          )}
        </Suspense>
        <GridwallContentWrap className="content" ref={gridwallRef}>
         <GridwallHeader
            currentPath={currentPath}
            metaInformation={metaInformation}
            isOneTalk={isOneTalk}
            is5gsmartphones={is5gsmartphones}
            isSearchLayout={isSearchLayout}
            isTabLayout={isTabLayout}
            isBogo={isBogo}
            totalResults={totalResults}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            fetchNextItems={fetchNextItems}
            toggleFilters={toggleFilters}
            showCartDetailsModal={showCartDetailsModal}
            setshowCartDetailsModal={setshowCartDetailsModal}
            hideBreadcrumbs={isPlanFirstFlow || fourGData?.showHeroCopyForBundle}
            onClickHandlerPopularDevice = {onClickHandlerPopularDevice}
            onClickHandlerLTEDevice = {onClickHandlerLTEDevice}
            onDetailsClick = {onDetailsClick}
          /> 
          <MarginSpacerXL />
          <div style={{maxWidth: "1272px", marginLeft: "auto", marginRight: "auto", paddingLeft: "1rem", paddingRight: "1rem"}}>
            {isPOYDFlow && pageData?.isPOYDFromGridwall && <POYDNotification />}
          </div>
          {isTabLayout && !isBogo && pathnotIncluded && (
            <GridwallStickyTabBar headerHeight={headerHeight}>
              <GridwallTabBar>
                <GridwallTabs
                  category={props?.category}
                  basePath={BASE_PATH}
                  currentPath={currentPath}
                  cpoFilter={props?.cpoFilter}
                  deviceFilters={deviceFilters}
                  isOCPO={props?.cpoFilter === "OCPO"}
                  deviceTabForOCPO={setDeviceTabForOCPO}
                  brandFilter={props?.brandFilter}
                  setBrandFilter={setBrandFilter}
                  filterData={filterData}
                  enableFreeTab={enableFreeTab == "Y"}
                />
              </GridwallTabBar>
            </GridwallStickyTabBar>
          )}
          {aem?.["promo-banner"] && aem?.["promo-banner"]?.[currentPath] ? (
            <GridwallHeaderWrap className="full-width">
              <PromoBannerLarge
                promoData={aem?.["promo-banner"]?.[currentPath]}
              />
            </GridwallHeaderWrap>
          ) : (
            <></>
          )}

          <CustomGridwallContainer>
            {pageData?.apiError && (
              <Notification
                type="error"
                title={t("gridwall.err_addUpdate", { ns: "gridwall" })}
                fullBleed={true}
                inlineTreatment={false}
                className="notification"
              />
            )}

             {!isBogo ? (
              <>
              <FilterSortWrap
                headerHeight={headerHeight}
                className="full-width bottom-pad gridwall-header"
              >                     
                <FilterBoxWrap>
                  {!ready || pageData?.isFromShoppingCart ? (
                    <></>
                  ) : (
                    <GridwallFilterBoxes
                      filters={deviceFilters}
                      tradeInToggle={tradeInToggle}
                      showTradeInToggle={showTradeInToggle}
                      filterData={filterData}
                      brandFilter={brandFilter || props?.brandFilter}
                      setBrandFilter={setBrandFilter}
                     
                      simFilter={props?.simFilter}
                      
                      setFilters={(val) => {
                        const params = searchParams;
                        if (params.get("page")) {
                          params.set("page", 1);
                          setSearchParams(params);
                          getUpdateSearchParams();
                        }
                        setDeviceFilters(val);
                        dispatch(setFilterSelected(val));
                      }}
                     
                      setCurrentPath={() => reloadGWPath()}
                    />
                  )}

                  {!ready ? (
                    <></>
                  ) : (
                    <FilterClearWrap>
                      {deviceFilters &&
                        Object.keys(deviceFilters)?.length &&  ClearAll && clearAllFilters
                        ? (
                          <TextLink
                          size="medium"
                          disabled={false}
                          kind="standalone"
                          style={{marginTop : "50px"}}
                          onClick={() => {
                             onClearFilter();
                              }}
                          surface="lightPrimary"
                        >
                          {aem?.labels?.clearAll}
                        </TextLink>
                      ) : (
                        <> </>
                      )}
                    </FilterClearWrap>
                  )}
                </FilterBoxWrap>
              </FilterSortWrap>
               {isMobileFixedResolution ? (
               <FilterTitle>
                         <div style={{ display: "flex", justifyContent: "space-between", width: "100%",paddingRight:"10px",paddingLeft:"10px",alignItems:"center"}}>
                            <Text kind="body" size="large">
                              {`${totalResults ?? 0} ${t("gridwall.labels.results", {
                                ns: "gridwall",
                              })}`}
                          </Text> 
                       <Button
                          size="small"
                          disabled={false}
                          use="secondary"
                          onClick={toggleFiltersTypes}
                        >
                          {aem?.labels?.filters}
                        </Button>
                         </div>
                      </FilterTitle>
              ) : (
                <></>
              )}

                  {isMobile ?(
                       <FilterTitle>
                         <div style={{ display: "flex", justifyContent: "space-between", width: "100%",paddingRight:"10px",paddingLeft:"10px",alignItems:"center"}}>
                         <Text kind="body" size="large">
                              {`${totalResults ?? 0} ${t("gridwall.labels.results", {
                                ns: "gridwall",
                              })}`}
                          </Text>
                       <Button
                          size="small"
                          disabled={false}
                          use="secondary"
                          onClick={toggleFiltersTypes}
                        >
                          {aem?.labels?.filters}
                        </Button>
                         </div>
                      </FilterTitle>
                      
                  ):(<></>)}
             
              </>
            ) : (
              <MarginSpacer2XL />
            )}

            <Grid
              bleed="1440"
              colSizes={{
                mobile: 1,
                tablet: 1,
                desktop: 3,
              }}
            >
              <RowNoPad>
                <ColContainer
                  colSizes={{
                    mobile: 2,
                    tablet: 4,
                    desktop: 3,
                  }}
                >
                  <Suspense fallback={<></>}>
                    {!ready ? (
                      <></>
                    ) : (
                      <GridwallFilterBar
                        brandFilter={brandFilter ?? props?.brandFilter}
                        categ={props?.category}
                        setBrandFilter={setBrandFilter}
                        tradeInToggle={tradeInToggle}
                        setTradeInToggle={setTradeInToggle}
                        showTradeInToggle={showTradeInToggle}
                        basePath={BASE_PATH}
                        aemContent={aem}
                        category={props?.brandFilter}
                        filterData={filterData}
                        filters={deviceFilters}
                        setFilters={(val) => {
                          const params = searchParams;
                          if (params.get("page")) {
                            params.set("page", 1);
                            setSearchParams(params);
                            getUpdateSearchParams();
                          }
                          setDeviceFilters(val);
                          dispatch(setFilterSelected(val));
                        }}
                        setViewResults={setViewResults}
                        sortOptions={sortDeviceOptions}
                        sortBy={sortBy}
                        setSortBy={setSortBy}
                        showFilters={showFilters}
                        toggleFilters={toggleFilters}
                        showFiltersTypes={showFiltersTypes}
                        toggleFiltersTypes={toggleFiltersTypes}
                        totalResults={totalResults}
                        filterAccordionsAll={filterAll}
                        onClearFilter={onClearFilter}
                        filtersApplied={pageData?.filterApplied}
                        location={location}
                        headerHeight={headerHeight}
                        brandSelectedOnTab={currentPath}
                        simFilter={props?.simFilter}
                        isBogo={isBogo}
                        sortDeviceOptions={sortDeviceOptions}
                        aem={aem}
                      />
                    )}
                  </Suspense>
                </ColContainer>

                <Col
                  colSizes={{
                    mobile: 4,
                    tablet: 8,
                    desktop: 9,
                  }}
                >
                  <Suspense fallback={<></>}>
                    {/* {!ready ? (
                      <></>
                    ) : ( */}
                      <Gridwall
                        gridData={deviceList}
                        loadEmptyDataContainer={loadEmptyDataContainer}
                        tradeInToggle={tradeInToggle}
                        showTradeInToggle={showTradeInToggle}
                        pageNum={pageNumParam}
                        loadFunc={(e) => {
                          const params = searchParams;
                          params.set("page", sanitizeNumber(e));
                          setSearchParams(params);
                          getUpdateSearchParams();
                          fetchNextItems(e);
                        }}
                        hasMore={hasMore}
                        totalResults={totalResults}
                        initialLoad={false}
                        onClickHandler={onGridwallClickHandler}
                        showDPP={true}
                        sortBy={sortBy}
                        onCompareSelect={onCompareSelect}
                        selectedCompare={selectedCompare}
                        byodCard={!isBogo ? byodCard : null}
                        GWJointOfferCard={GWJointOfferCard}
                        isBogo={isBogo}
                        hotspotPromo={
                          (props?.category === "mobile-hotspots" &&
                            aem?.hotspot?.show) ||
                          deviceList[0]?.category?.includes(
                            "BroadbandAccess Devices"
                          )
                        }
                        laptopPromo={
                          (props?.category === "laptops" || isLaptopSelected) &&
                          aem?.connectedLaptops?.show
                        }
                        hidePromoBadges={isBogo}
                        aemContent={aem}
                        onClearFilter={() => onClearFilter()}
                        selectedCategory={deviceFilters["categoryList"]}
                        pageNumClicked={pageNumClicked}
                        brandFilter={brandFilter}
                        mixedCartApplied={mixedCartApplied}
                        planFirstData={planFirstData?.isShopPhoneDevice || false}
                        onClickHandlerPopularDevice = {onClickHandlerPopularDevice}
                  
                        
                        onClickHandlerLTEDevice = {
                          ()=>
                          {
                            isQualModalOpen ?  
                            setOpenLQModal(true) :
                            onClickHandlerLTEDevice("4G");
                           }
                          }
                        detailsClick = {detailsClick}
                        onDetailsClick = {onDetailsClick}
                      />
                    {/* )} */}
                  </Suspense>
                </Col>
              </RowNoPad>
            </Grid>
          </CustomGridwallContainer>
          <Suspense fallback={<></>}>
            {!!(showSeoFooter && seoFooterData) && !fourGData?.showHeroCopyForBundle && (
              <SEOFooter data={seoFooterData} />
            )}
          </Suspense>
        </GridwallContentWrap>
        {showCompareLimitModal && (
          <Modal
            opened={showCompareLimitModal}
            onOpenedChange={setShowCompareLimitModal}
            disableFocusLock={true}
          >
            <ModalTitle>
              <span
                size="large"
                dangerouslySetInnerHTML={{
                  __html: t("gridwall.headingFourDeviceCompare", {
                    ns: "gridwall",
                  }),
                }}
              />
            </ModalTitle>
            <ModalBody>
              <span
                dangerouslySetInnerHTML={{
                  __html: t("gridwall.four-device-compare", { ns: "gridwall" }),
                }}
              />
            </ModalBody>
          </Modal>
        )}
        <div className="compare-devices">
          <Suspense fallback={<></>}>
            <GridwallCompare
              aem={aem}
              selectedProducts={pageData?.compareDevices}
              tileCloseFn={removeCompareDevice}
              topOffset={headerHeight}
              count={length}
            />
          </Suspense>
        </div>
        {globalData.flow === 'plans-first' && plansFirstCategories.includes(globalData.category) && Object.keys(pageData?.compareDevices || {})?.length === 0 && 
          pageData?.isPlansFirstCategory && !globalData.isPlanFirstFlowCompleted && 
        <PlansFirstStickyContainer>
          <Suspense fallback={<></>}>
            <GridwallPlansFirstDevices
              selectedProducts={pageData?.plansFirstDevices}
            />
          </Suspense>
        </PlansFirstStickyContainer>
        }
        {showPOYDMaxDeviceModal && <POYDMaxDeviceModal opened={showPOYDMaxDeviceModal} onOpenedChange={setShowPOYDMaxDeviceModal} />}
      </MobilityGridwallWrap>
    </ErrorBoundary>
  );
};

const sortDeviceOptions = [
  {
    name: "Featured",
    value: "featured",
  },
  {
    name: "Price low to high",
    value: "low",
  },
  {
    name: "Price high to low",
    value: "high",
  },
  {
    name: "Newest",
    value: "newest",
  },
];

const RowNoPad = styled(Row)`
  @media only screen and (max-width: 545px) {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

const ColContainer = styled(Col)`
  padding-left: 1rem !important;
  padding-right: 0.4rem !important;
`;

const MobilityGridwallWrap = styled.div`
  min-height: 37.5rem;
  margin: 0px !important;
  [class^="promo-banner"]{
  width:100%;
  }

  .gridwall-header {
    display: flex;
    flex-wrap: wrap;
    max-width: 1272px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    overflow-x:hidden;
    overflow-y:hidden;
  }

  .ezYXtw {
    padding-bottom: 0;
  }

  .notification {
    &:nth-child(1) {
      opacity: 1 !important;
    }
  }

  .promo-banner-large {
    width: 100%;
  }
`;

const GridwallContentWrap = styled.div`
  .header {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .side-padding {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .call-btn-container {
    position: fixed;
    right: 0;
    top: 450px;
    z-index: 9999;
    .call-btn {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      background-color: #000000;
      border: 2px solid #FFF;
      color: #FFF;
      border-radius: 10px;
      height: 70px;
      width: 25px;
      padding: 5px;
      span {
        margin-bottom: 5px;
        transform: rotate(270deg);
      }
    }
  }

  .top-pad {
    padding-top: 1rem;
  }

  .bottom-pad {
    padding-bottom: 1rem;
  }

  .full-width {
    width: 100%;
  }

  .left-flex {
    width: 66%;
  }

  .right-flex {
    display: flex;
    flex-direction: row-reverse;
    gap: 45px;
    margin-left: auto;
    padding: 16px 0;
  }
  @media screen and (max-width: 767px) {
    .bottom-pad {
      padding-bottom: 0rem;
    }
  }
`;

const GridwallHeaderWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1272px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;

  .chat-link {
    margin-top: 1rem;
    margin-right: 1.5rem;
  }

  .contact-sales {
    margin-top: 1rem;
    margin-right: 1.5rem;
  }

  .search-input {
    margin-top: 1rem;
    max-width: 66%;

    @media (max-width: 800px) {
      max-width: 100%;
    }
  }
`;

export  const StyledDropDownList = styled.div`
  padding-top:1rem;
  // padding-left:2px;
  > div {
    min-width: 268px !important;
    background: white !important;
  }
`;

export const SortByDropdown = styled.div`
  display: flex;
  align-items: center;
  flex-basis: unset;
  max-width: 100%;
  width: 100%;

  & > p {
    width: 100%;
    text-align: right;
    padding-right: 10px;
  }

  options {
    text-align: center;
  }

  @media (max-width: 800px) {
    & > p {
      width: 80%;
    }
  }

  @media (max-width: 545px) {
    & > p {
      text-align: left;
    }
  }
`;

export const MobFilterSortWrap = styled.div`
  display: flex;
  gap: 10px;
`;

export const SortByWrapper = styled.div`
  justify-content: flex-end !important;
  width: 32%;
  order: 2;

  @media (max-width: 900px) {
    width: 60%;

    select {
      padding: 0.25rem 1.5rem 0.25rem 0 !important;
    }
  }

  @media (max-width: 545px) {
    width: 100%;
    order: 1;
    padding-bottom: 1rem;
    border-bottom: 1px solid #D8DADA;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

export const FilterBoxWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  & > div {
    height: fit-content;
    flex-wrap: wrap;
    gap: 0.5rem;

    & div {
      border-radius: 5px;
      display: flex;
      align-items: center;
      height: auto;
      padding: 3px 2px 3px 3px;
      gap: 5px;

      &:last-child {
        gap: 0px;
      }
    }
  }

  @media (max-width: 900px) {
    width: 40%;
  }

  @media (max-width: 545px) {
    width: 100%;
    order: 3;
  }
`;


export const FilterSortWrap = styled.div`
  justify-content: space-between !important;
  display: flex !important;
  flex-wrap: wrap;
  max-width: 1272px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;

  &.gridwall-header {
    max-width: 1272px;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 2rem;

    @media only screen and (max-width: 545px) {
      padding-bottom: 24px !important;
      background-color: #f7f2e9; 
    }
  }

  @media only screen and (max-width: 545px) {
    position: sticky !important;
    top: ${({ headerHeight }) => (headerHeight > 0 ? 44 + headerHeight : 44)}px;
    z-index: 4;
    background-color: #f6f6f6;
  }
`;

const FilterTitle = styled.div`
padding: 10px;
    display: flex;
    align-items: flex-end;
    justify-content: end;
`;

const FilterClearWrap = styled.div`
  margin-left: 0.5rem;
  padding-left:8px;

  & > span > a {
    margin-top: 30px !important;
  }

  & > button {
    border: none;
    text-decoration: underline;
    line-height: 1rem;
    color: #000000;

    &:hover {
      border: none !important;
      box-shadow: none !important;
    }

    span {
      padding: 0px !important;
    }
  }
`;


const PlansFirstStickyContainer = styled.div`
position:fixed;
bottom:0px;
left:0px;
z-index: 99;
background: white;
width:100vw;
border-top:1px solid #D8DADA;
@media screen and (max-width: 767px) {
  .h5 {
    margin-left: 1rem;
  }
}
`

export default React.memo(MobilityGridwall);
